import { Icon, Modal, Output, OverlayBackdrop, RadiobuttonList, Textarea, TooltipTrigger } from "@ds/ds-snam/react";
import { Button } from "@ds/ds-snam/react";
import { ReactElement, useState, useRef, useEffect, useCallback } from "react";
import { DsLayout, EntityType, FormMode, RoutePath, UICommand, DocumentType } from "shared/constants";
import { useTranslation } from "react-i18next";
import { ICheckListData, ICalendarDialogForm, ICalendarDialogFormData, ICalendarEvent } from "dataModels/b2b";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { Input as TextInput } from "@ds/ds-snam/react";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { bookSlot, changeStatus, downloadDocument, getCheckList, putCheckList } from "net/b2b";
import { INotificationAction } from "dataModels/stateModels/notification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "react-grid-system";
import TooltipIcon from "components/TooltipIcon";
import { RootState } from "state/appStore";
import DialogCalendar from "../../calendarView/DialogCalendar";
import DsHorizontalDivider from "components/DsHorizontalDivider";
import saveAs from "file-saver";


interface ICheckListFormProps {
}

const CheckListForm: React.FC<ICheckListFormProps> = (props): JSX.Element => {

    const { t } = useTranslation(["b2b", "app"]);
    const location = useLocation();
    const { codeIup } = useParams();
    const [ formData,setFormData ] = useState<ICheckListData|undefined>();
    const [disableSave,setDisableSave]=useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const [viewDialog,setViewDialog] = useState(false);


    const onRadioChange = (event: Event, id: string) => {
        if(formData){
            let currentFormData = {...formData};
            let selection:string|boolean = false;
            selection = (event as CustomEvent).detail.selectedRadio.value==='1'; //boolean
            currentFormData![id] = selection;
            setFormData(currentFormData);
        }
    }

    const getTitle = (title:string,subTitle?:string,tooltipText?:string) => {
        return <>
            {formData &&
                <div style={{marginBottom:'16px'}}>
                    <div style={{display:'flex',gap:'10px',alignItems: "center",color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                        <div style={{fontWeight:'bold'}}>{title}</div>
                        {tooltipText && 
                            
                            <>
                            <TooltipTrigger
                                tooltipPosition="top"
                                tooltipText={tooltipText}
                                zIndex={999}
                                ariaDescribedBy="tooltip-info"
                            >
                                <Icon
                                    iconSize="medium"
                                    icon="icon-info-circle"
                                    style={{ color: "var(--interaction-active)" }}
                                    id="tooltip-anchor-element-id"
                                    data-tooltip-id={title+"_Tooltip_id"}
                                    data-tooltip-variant="light"
                                    data-tooltip-html={tooltipText}
                                />    
                            </TooltipTrigger>
                            {/*<div style={{ display: "flex", alignItems: "flex-start", flexDirection:"column", gap: "4px" }}>
                                <TooltipIcon tooltipId={title+"_Tooltip_id"} tooltipData={tooltipText}/>
                            </div>*/}
                            </>
                        }
                    </div>
                    {subTitle && 
                        <div style={{color:"grey"}}>{formData![subTitle as keyof ICheckListData]}</div>
                    }
                </div>
            }
        </>
    }

    const getRadioButtonComponent = (id:string) => {
        if(formData!==undefined){
            let splitOption = [
                { "id": "1", "label": (id!=='vehicleConditionValue')?t('general.yesLabel', {ns:'app'}):t("checkList.general.3"), "value": "1" }, 
                { "id": "0", "label": (id!=='vehicleConditionValue')?t('general.noLabel', {ns:'app'}):t("checkList.general.4"), "value": "0" },
            ];
            let selection=undefined;
            if(formData![id as keyof ICheckListData]!==null){
                selection = Number(formData![id as keyof ICheckListData]).toString();
            }
            return  <>
                        <div style={{marginTop:'4px'}}>
                            <RadiobuttonList
                                radioListData={splitOption ? splitOption : []}
                                radioListName="Radio List"
                                radioListDisabled={false}
                                radioListOrientation="horizontal"
                                isRequired={true}
                                selectedRadioID={selection}
                                onRadioChange={(event: Event) => {
                                    onRadioChange(event, id)
                                }}
                            />
                        </div>
                    </>
        }
    }

    const getTextInputComponent = (id:string) => {
        if(formData!==undefined){
            return(
                <>
                <TextInput
                    inputPlaceholder={t("checkList.general.9")}
                    inputValue={formData![id as keyof ICheckListData] as string}
                    inputId={id}
                    input-event-type="single_character"
                    onInputChange={(inputEvent: Event) => {
                        let value = (inputEvent as CustomEvent).detail.input.value;
                        let currentFormData = formData;
                        (currentFormData![id as keyof ICheckListData] as string) = value;
                        setFormData(currentFormData);
                    }
                    }
                />
                {/*<Textarea
                    textareaLabel={t("checkList.general.9")}
                    textareaName={id}
                    textareaId={id}
                    textareaMaxChar={500}
                    textareaRows={1}
                    isDisabled={false}
                    textAreaValue={formData![id as keyof ICheckListData] as string}
                    onInputChange={(inputEvent: Event) => {
                        let value = (inputEvent as CustomEvent).detail.input.value;
                        let currentFormData = formData;
                        (currentFormData![id as keyof ICheckListData] as string) = value;
                        setFormData(currentFormData);
                    }}
                ></Textarea>*/}</>
            )
        }
    }

    const getDivider = () => {
        return  <DsHorizontalDivider/>
    }

    useEffect(()=>{
        if(formData && (formData?.codeIupCorrispondence!==null&&
            formData?.identityDocCorrispondence!==null&&
            //formData?.driverLicenceCorrispondence!==null&&
            formData?.vehicleConditionValue!==null&&
            formData?.instructionsDocumentValue!==null&&
            formData?.orangeLicencePlateValue!==null&&
            formData?.loadWedgesValue!==null&&
            formData?.fireExtinguisherValue!==null&&
            formData?.atexValue!==null&&
            //formData?.gnlValue!==null&&
            //formData?.insulationFailureValue!==null&&
            formData?.dpIpresenceValue!==null&&
            formData?.sealsPresenceValue!==null&&
            //formData?.kitPresenceValue!==null&&
            formData?.boardingValue!==null&&
            (formData.licencePlateTruckTractorValue!==""? formData?.licencePlateTruckTractorCorrispondence!==null:true)&&
            (formData.licencePlateTankerTruckValue!==""? formData?.licencePlateTankerTruckCorrispondence!==null:true)&&
            (formData.licencePlateIsoContainerValue!==""? formData?.licencePlateIsoContainerCorrispondence!==null:true)&&
            (formData.licencePlateFlatBedValue!==""? formData?.licencePlateFlatBedCorrispondence!==null:true)
        )){
            setDisableSave(false);
        }
    },[ formData ])

   

    const loadData = useCallback(() => {
        dispatch(requestPending());
        getCheckList(codeIup!)
            .then((response: any) => {
                setFormData(response);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }, [dispatch]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const saveFormData = () => {
        //console.log(formData);
        dispatch(requestPending());
        putCheckList(formData!)
            .then((response: any) => {
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: t("checkList.general.7"),
                    description: t("checkList.general.8"),
                    status: "confirm",
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.B2B_BOOKINGS_INFO); 
            })
            .catch(error => {
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: "Error",
                    description: error,
                    status: "error",
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.B2B_BOOKINGS_INFO); 
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }

    function formatDatetime(dateStr:string) {
        const dt = new Date(dateStr);
        if (isNaN(dt.getTime())) {
            return "Error: date format not valid";
        }
        
        const day = String(dt.getDate()).padStart(2, '0');
        const month = String(dt.getMonth() + 1).padStart(2, '0');
        const year = dt.getFullYear();
        const hours = String(dt.getHours()).padStart(2, '0');
        const minutes = String(dt.getMinutes()).padStart(2, '0');
        
        return `${day}.${month}.${year} | ${hours}:${minutes}`;
    }

    const downloadChecklistDocument = () => {
            downloadDocument(codeIup!, EntityType.CHECKLIST, DocumentType.CHECKLIST)
                .then((response) => {
                    let file = new File(
                        [response.data],
                        "Checklist" + ".pdf"
                    );
                    saveAs(file);
                })
                .catch((error) => {
                    console.log(error);
                });
        }

    return (
        <>
            
            {/*<div>{location.state.command}</div>
            <div>{codeIup}</div>*/}
            <div className="boxTitle" style={{ fontSize: '30px' }}>
                {t("checkList.titles.0")}{/*Compilazione Checklist La Spezia*/}
            </div>
            <div style={{marginLeft:'10px',color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                <li>{t("checkList.titles.1")}{/*Eseguire i controlli e le attività elencate di seguito.*/}</li>
                <li>{t("checkList.titles.2")}{/*Segnalare al Responsabile Gestione Operativa (RGO) eventuali anomalie rilevate*/}</li>
            </div>

            <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black",width:'100%'}}>
                <div style={{float:'right', display:'flex',gap:'10px'}}> 
                    <p style={{fontWeight:'bold'}}>{t("checkList.titles.5")}</p> 
                    <p>{(formData?.lastUpdateTimestamp && formData?.lastUpdateTimestamp!==''&& formData?.lastUpdateTimestamp!==null)?formatDatetime(formData?.lastUpdateTimestamp):'-'}</p>
                </div>
            </div>

            <div className="box" style={{ marginTop: '50px', background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-50, #EFF1F5)" }}>
                <Row style={{ marginBottom: "35px" }}>
                    <Col xs={12} md={12}>
                    <div className="boxTitle" style={{ fontSize: '25px' }}>
                        {t("checkList.titles.3")}{/*Attività preliminari*/}
                    </div>
                    </Col>
                </Row>

                <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.0"),'identityDocValue',t("checkList.tooltipV2.0"))} {/** perchè ste me li valorizza entrambi? togliere */}
                        {location.state.command===FormMode.EDIT.toString() ?
                            getRadioButtonComponent('identityDocCorrispondence')
                        :
                            <><Output
                                outputText={(formData?.identityDocCorrispondence ? t("checkList.general.5") : t("checkList.general.6"))}
                            ></Output>
                            {/*(formData?.identityDocCorrispondence ? t("checkList.general.5") : t("checkList.general.6"))*/}</>
                        }
                    </Col>
                    {/*<Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.1"),'driverLicenceValue')}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('driverLicenceCorrispondence')
                        :
                        <Output
                                outputText={(formData?.driverLicenceCorrispondence ? t("checkList.general.5") : t("checkList.general.6"))}
                            ></Output>
                            
                        }
                    </Col>*/}
                </Row>

                {getDivider()}

                <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.2"),'reservationCode',t("checkList.tooltipV2.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('codeIupCorrispondence')
                        :
                        <Output
                                outputText={(formData?.codeIupCorrispondence ? t("checkList.general.5") : t("checkList.general.6"))}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                {getDivider()}



                {
                    <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                        {formData?.licencePlateTruckTractorValue!=="" &&<Col xs={12} md={6}>
                            {getTitle(t("checkList.sub_titles.3"),'licencePlateTruckTractorValue',t("checkList.tooltipV2.2"))}
                            {location.state.command===FormMode.EDIT.toString() ? 
                                getRadioButtonComponent('licencePlateTruckTractorCorrispondence')
                            :
                            <Output
                                    outputText={(formData?.licencePlateTruckTractorCorrispondence ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                                ></Output>
                                
                            }
                        </Col>}
                        {formData?.licencePlateTankerTruckValue!=="" && <Col xs={12} md={6}>
                            {getTitle(t("checkList.sub_titles.4"),'licencePlateTankerTruckValue',t("checkList.tooltipV2.3"))}
                            {location.state.command===FormMode.EDIT.toString() ? 
                                getRadioButtonComponent('licencePlateTankerTruckCorrispondence')
                            :
                            <Output
                                    outputText={(formData?.licencePlateTankerTruckCorrispondence ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                                ></Output>
                                
                            }
                        </Col>}
                    </Row>
                }

                {
                    <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                        {formData?.licencePlateFlatBedValue!=="" && <Col xs={12} md={6}>
                            {getTitle(t("checkList.sub_titles.5"),'licencePlateFlatBedValue',t("checkList.tooltipV2.4"))}
                            {location.state.command===FormMode.EDIT.toString() ? 
                                getRadioButtonComponent('licencePlateFlatBedCorrispondence')
                            :
                            <Output
                                    outputText={(formData?.licencePlateFlatBedCorrispondence ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                                ></Output>
                                
                            }
                        </Col>}
                        {formData?.licencePlateIsoContainerValue!=="" && <Col xs={12} md={6}>
                            {getTitle(t("checkList.sub_titles.6"),'licencePlateIsoContainerValue',t("checkList.tooltipV2.5"))}
                            {location.state.command===FormMode.EDIT.toString() ? 
                                getRadioButtonComponent('licencePlateIsoContainerCorrispondence')
                            :
                            <Output
                                    outputText={(formData?.licencePlateIsoContainerCorrispondence ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                                ></Output>
                                
                            }
                        </Col>}
                    </Row>
                }


                {getDivider()}

                <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.7"),"",t("checkList.tooltipV2.6"))}
                        {location.state.command===FormMode.EDIT.toString() ?
                            getRadioButtonComponent('vehicleConditionValue')
                        :
                        <Output
                                outputText={(formData?.vehicleConditionValue ? t("checkList.general.3") : t("checkList.general.4"))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('vehicleConditionNotes')
                        :
                        <Output
                                outputText={(formData?.vehicleConditionNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.8"),"",t("checkList.tooltipV2.7"))}
                        {location.state.command===FormMode.EDIT.toString() ?
                            getRadioButtonComponent('instructionsDocumentValue')
                        :
                        <Output
                                outputText={(formData?.instructionsDocumentValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('instructionsDocumentNotes')
                        :
                            <Output
                                outputText={(formData?.instructionsDocumentNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                <Row style={{ marginBottom: "35px" ,color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.9"),"",t("checkList.tooltipV2.8"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('orangeLicencePlateValue')
                        :
                        <Output
                                outputText={(formData?.orangeLicencePlateValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('orangeLicencePlateNotes')
                        :
                        <Output
                                outputText={(formData?.orangeLicencePlateNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                <Row style={{ marginBottom: "35px" ,color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.10"),"",t("checkList.tooltipV2.9"))}
                        {location.state.command===FormMode.EDIT.toString() ?
                            getRadioButtonComponent('loadWedgesValue')
                        :
                        <Output
                                outputText={(formData?.loadWedgesValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('loadWedgesNotes')
                        :
                        <Output
                                outputText={(formData?.loadWedgesNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                <Row style={{ marginBottom: "35px" ,color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.11"),"",t("checkList.tooltipV2.10"))}
                        {location.state.command===FormMode.EDIT.toString() ?
                            getRadioButtonComponent('fireExtinguisherValue')
                        :
                        <Output
                                outputText={(formData?.fireExtinguisherValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('fireExtinguisherNotes')
                        :
                        <Output
                                outputText={(formData?.fireExtinguisherNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.12"),"",t("checkList.tooltipV2.11"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('atexValue')
                        :
                        <Output
                                outputText={(formData?.atexValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('atexNotes')
                        :
                        <Output
                                outputText={(formData?.atexNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                {/*<Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.13"),"",t("checkList.tooltipV2.12"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('gnlValue')
                        :
                        <Output
                                outputText={(formData?.gnlValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('gnlNotes')
                        :
                        <Output
                                outputText={(formData?.gnlNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>*/}

                {/*<Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.14"),"",t("checkList.tooltipV2.13"))}
                        {location.state.command===FormMode.EDIT.toString() ?
                            getRadioButtonComponent('insulationFailureValue')
                        :
                        <Output
                                outputText={(formData?.insulationFailureValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('insulationFailureNotes')
                        :
                        <Output
                                outputText={(formData?.insulationFailureNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>*/}

                <Row style={{ marginBottom: "35px" ,color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.15"),"",t("checkList.tooltipV2.14"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('dpIpresenceValue')
                        :
                        <Output
                                outputText={(formData?.dpIpresenceValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('dpIpresenceNotes')
                        :
                        <Output
                                outputText={(formData?.dpIpresenceNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.16"),"",t("checkList.tooltipV2.15"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('sealsPresenceValue')
                        :
                        <Output
                                outputText={(formData?.sealsPresenceValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('sealsPresenceNotes')
                        :
                        <Output
                                outputText={(formData?.sealsPresenceNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>

                {/*<Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.18"),"",t("checkList.tooltipV2.16"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('kitPresenceValue')
                        :
                        <Output
                                outputText={(formData?.kitPresenceValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('kitPresenceNotes')
                        :
                        <Output
                                outputText={(formData?.kitPresenceNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>*/}

                <Row style={{ marginBottom: "35px",color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Col xs={12} md={6}>
                        {getTitle(t("checkList.sub_titles.17"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getRadioButtonComponent('boardingValue')
                        :
                        <Output
                                outputText={(formData?.boardingValue ? t('general.yesLabel', {ns:'app'}) : t('general.noLabel', {ns:'app'}))}
                            ></Output>
                            
                        }
                    </Col>
                    <Col>
                        {getTitle(t("checkList.general.1"))}
                        {location.state.command===FormMode.EDIT.toString() ? 
                            getTextInputComponent('boardingNotes')
                        :
                        <Output
                                outputText={(formData?.boardingNotes)}
                            ></Output>
                            
                        }
                    </Col>
                </Row>
                
            </div>
            {viewDialog && 
                <DialogCalendar
                    command={UICommand.DELETE}
                    selectedEvent={undefined}
                    loadEvents={()=>{}}
                    onClose={(command?: UICommand) => {
                        setViewDialog(false);
                    }}
                    externalLogic={saveFormData}
                />
            }
            <div style={{width:'fit-content',float:'right'}}>
                {location.state.command===FormMode.EDIT.toString() &&
                    <>
                        <Button
                            style={{ float: 'left', marginTop: '20px',marginRight:'10px' }}
                            id="backButton"
                            buttonType="button"
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonLabel={t('general.buttons.cancel', { ns: 'app' })}//"Annulla"
                            isDisabled={false}
                            onClickEvent={() => {
                                navigate(RoutePath.B2B_BOOKINGS_INFO);         
                            }}
                        />
                        
                        <Button
                            style={{ float: 'left', marginTop: '20px' }}
                            id="backButton"
                            buttonType="button"
                            buttonUIVariant="primary"
                            buttonSize="medium"
                            buttonLabel={t('general.buttons.save', { ns: 'app' })}//"Salva"
                            isDisabled={
                                disableSave
                            }
                            onClickEvent={() => {
                                setViewDialog(true)               
                            }}
                        />
                    </>
                }
                {location.state.command===FormMode.READ.toString() &&
                    <>
                        <Button
                            style={{ float: 'left', marginTop: '20px',marginRight:'10px' }}
                            id="backButton"
                            buttonType="button"
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonLabel={t('general.buttons.back', { ns: 'app' })}//"Back"
                            isDisabled={false}
                            onClickEvent={() => {
                                navigate(RoutePath.B2B_BOOKINGS_INFO)            
                            }}
                        />
                        <Button
                            style={{ float: 'left', marginTop: '20px',marginRight:'10px' }}
                            id="backButton"
                            buttonType="button"
                            buttonUIVariant="primary"
                            buttonSize="medium"
                            buttonLabel={t('general.buttons.download_short', { ns: 'app' })}//"Scarica"
                            isDisabled={false}
                            onClickEvent={() => {
                                downloadChecklistDocument()
                            }}
                        />
                    </>
                }
            </div>
        </>
    );
}

export default CheckListForm;